import { createRoot } from "react-dom/client";
import React, { useEffect, useState } from "react";
import { questions as rawQuestions, results, results as rawResults } from "./data";
import { Radio1 } from "../../../../assets/js/components/form-elements";
import { clsx } from "clsx";
import { sendYaMetrikaGoal } from "../../../../assets/js/misc/ya-metrika";

const renderQuizes = () => {
  const $containers = document.querySelectorAll('.js-quiz');

  $containers.forEach(($container) => {
    const $itemNode = $container.querySelector('.js-quiz__node');
    renderQuiz($itemNode);
  });
};

const renderQuiz = ($rootNode) => {
  const root = createRoot($rootNode);
  root.render(
    <React.StrictMode>
      <Quiz/>
    </React.StrictMode>
  );
}

const Quiz = () => {
  const isDebug = false;
  const [initialized, setInitialized] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [answer2question, setAnswer2question] = useState({});
  const [formState, setFormState] = useState({});
  const [score, setScore] = useState(0);
  const [finalInfo, setFinalInfo] = useState({
    gte: 1000,
    lte: 1001,
    text: 'text',
    wood_volume: 1,
    wood_price: 1,
    coal_volume: 1,
    coal_price: 1,
    total_price: 1,
  });

  const [phase, setPhase] = useState('intro');
  // const [phase, setPhase] = useState('final');
  const startQuiz = () => {
    setPhase('questions');
    sendYaMetrikaGoal('drova_test_started');
  };
  const goToResults = () => {
    console.log('formState', formState);
    let score_ = 0;
    for (const question of questions) {
      const answerIdForQuestion = formState[question.id];
      for (const answer of question.answers) {
        if (answer.id === answerIdForQuestion) {
          score_ += answer.value;
          break;
        }
      }
    }
    setScore(score_);
    console.log('score_', score_);

    for (const result of rawResults) {
      if (score_ >= result.gte && score_ <= result.lte) {
        setFinalInfo(result);
        setPhase('final');
        sendYaMetrikaGoal('drova_test_finished');
        return;
      }
    }

    alert('Ошибка: не удалось посчитать результат');
  };

  const onChangeCheckbox = (e) => {
    const answerId = e.target.id; // TODO or e.target.value
    const questionId = answer2question[answerId];
    const newFormState = {...formState};
    newFormState[questionId] = answerId;
    setFormState(newFormState);
  };

  const [firstSlide, setFirstSlide] = useState('');
  const [currentSlide, setCurrentSlide] = useState(null); // object, question
  const [lastSlide, setLastSlide] = useState('');
  const setSlide = (newslideId) => {
    for (const question of questions) {
      if (question.id === newslideId) {
        setCurrentSlide(question);
        break;
      }
    }
  };

  useEffect(() => {
    setInitialized(true);

    const questions = [];
    let prevQuestionId = null;
    let prevQuestionIndex = -1;
    for (const rawQuestion of rawQuestions) {
      const question = {
        id: rawQuestion.id,
        text: rawQuestion.text,
        answers: rawQuestion.answers,
        prevQuestionId: null,
        nextQuestionId: null,
        indexInSourceArray: prevQuestionIndex + 1,
        visibleNumber: prevQuestionIndex + 2,
      };

      question.prevQuestionId = prevQuestionId ? prevQuestionId : null;
      prevQuestionId = question.id;

      if (prevQuestionIndex >= 0) {
        questions[prevQuestionIndex].nextQuestionId = question.id;
      }
      ++prevQuestionIndex;

      questions.push(question);
    }
    setQuestions(questions);
    console.log('questions', questions);

    setFirstSlide(questions[0].id);
    setCurrentSlide(questions[0]);
    const lastSlideIndex = questions.length >= 1 ? questions.length - 1 : 0;
    setLastSlide(questions[lastSlideIndex].id);

    const newAnswer2question = {};
    for (const question of questions) {
      for (const answer of question.answers) {
        newAnswer2question[answer.id] = question.id;
      }
    }
    setAnswer2question(newAnswer2question);

    const newFormState = {};
    for (const question of questions) {
      newFormState[question.id] = null;
    }
    setFormState(newFormState);
  }, []);

  if (! initialized) {
    return null;
  }

  return (
    <div className="dn-quiz">
      {phase === 'questions' && (
        <div className="dn-quiz__counter">
          {currentSlide.visibleNumber} / {questions.length}
        </div>
      )}

      {phase === 'intro' ? (
        <div className="dn-quiz__intro">
          <div className="dn-quiz__intro-header">Тест-калькулятор &laquo;Почем дровишки?&raquo;</div>
          <div className="dn-quiz__intro-desc">Сколько вам понадобилось бы дров (и денег), чтобы пережить зиму?</div>
          <button type="button" className="dn-quiz__intro-button dn-button2" onClick={startQuiz}>Начать тест</button>
        </div>
      ) : phase === 'questions' ? (
        <div className="dn-quiz__questions-wrapper">
          <div className="dn-quiz__items">
            {questions.map((question, question_index) => (
              <div className={clsx({'dn-question': true, 'dn-hidden': currentSlide.id !== question.id})} key={question.id}>
                <div className="dn-question__text">{question.text}</div>
                <div className="dn-question__answers">
                  {question.answers.map((answer, answer_index) => (
                    <div className="dn-question__answer" key={answer.id}>

                      <Radio1 text={answer.text}
                              checked={formState[question.id] === answer.id}
                              onChange={onChangeCheckbox}
                              input_id={answer.id}
                      />

                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="dn-quiz__nav">
            {currentSlide.prevQuestionId && (
              <button type="button" className="dn-quiz__nav-button dn-button2"
                      onClick={() => setSlide(currentSlide.prevQuestionId)}>Назад</button>
            )}
            {currentSlide.nextQuestionId && (
              <button type="button" className="dn-quiz__nav-button dn-button2"
                      disabled={! formState[currentSlide.id]}
                      onClick={() => setSlide(currentSlide.nextQuestionId)}>Далее</button>
            )}
            {! currentSlide.nextQuestionId && (
              <button type="button" className="dn-quiz__nav-button dn-button2"
                      disabled={! formState[lastSlide]}
                      onClick={goToResults}>Получить результаты</button>
            )}
          </div>
        </div>
      ) : phase === 'final' ? (
        <div className="dn-quiz__final">
          <div className="h3-style mb30">Спасибо, что прошли тест!</div>

          <div className="dn-quiz__final-results">
            <strong>Результаты:</strong><br />
            {/*- счёт: {score}<br />*/}
            {finalInfo.text}<br />
            {/*- сколько топлива: {finalInfo.wood_volume} куб м дров / {finalInfo.coal_volume} т угля<br />*/}
            {/*- в деньгах: {finalInfo.wood_price} ₽ / {finalInfo.coal_price} ₽<br />*/}
            Ваши расходы за&nbsp;отопительный сезон: <strong>~&nbsp;{finalInfo.total_price}&nbsp;₽</strong>
          </div>

          <div style={{display: 'flex', justifyContent: 'center', marginTop: '40px'}}>
            <a href="https://detinashi.ru/campaign/drova-2025/?utm_source=detinashi&utm_medium=site&utm_campaign=drova-quiz" target="_blank"
               className="dn-button2" onClick={() => sendYaMetrikaGoal('drova_test_goto_campaign')}>Подарить дрова</a>
          </div>

          <div className="dn-quiz__cat">
            <img src="/wp-content/themes/chidren/modules/quiz/assets/images/cat-1.jpg" alt="" />
          </div>

          <div className="dn-quiz__final-notes">
            <p style={{marginBottom: '1em'}}><strong>Пояснения</strong></p>

            <p style={{fontSize: '0.85em', marginBottom: '1em'}}>
              *  Результаты теста носят примерный / оценочный характер.
              Расходы за отопительный сезон в доме, который отапливается только русской печкой,
              зависят от множества факторов: вида печи,
              вида дров и вида угля для топки, степени утепленности дома,
              наличия подпола, региона проживания, точной отапливаемой площади зимой и т.д. и т.п.
            </p>

            <p style={{fontSize: '0.85em', marginBottom: '1em'}}>
              ** Стоимость дров принята за 3000 р за 1 куб м.
              Лучший выбор для отопления жилых помещений — колотые просушенные дрова лиственных пород.
              Дрова из хвойных пород дешевле, но сгорают быстро, выделяют мало тепла и много копоти.
            </p>

            <p style={{fontSize: '0.85em'}}>
              *** Стоимость угля вида «антрацит» принята за 10.000 руб за 1 тонну.
              Лучший выбор для отопления жилых помещений — хотя и самый дорогой —  именно антрацит.
              Он отличается большей теплоотдачей, бездымным горением и наименьшей зольностью.
              Также значительной статьёй расходов зимой может стать доставка угля и дров
              в удаленный населенный пункт; ремонт старой / дымящей печи.
            </p>

          </div>

          {isDebug && (
            <div style={{display: 'flex', justifyContent: 'center', marginTop: '40px'}}>
                <button type="button" className="dn-button2"
                        onClick={() => setPhase('intro')}>В начало</button>
            </div>
          )}
        </div>
      ) : <div>Инф-я не найдена. Перезагрузите страницу.</div>}

    </div>
  );
}

renderQuizes();
